export default {
      id: "ic_waiting-usage",
      viewBox: "0 0 50 50",
      url: "/" + "images/icons.3.109.2.svg#ic_waiting-usage",
      toString: function () {
        return this.url;
      }
    }